    <form
      [formGroup]="service.form"
      id="whats-app-contact"
      (ngSubmit)="submitForm()"
      validateOnSubmit
    >
      <!--<suite-custom-code-block-5>-->
      <!--</suite-custom-code-block-5>-->
            <div class="mt-2 fade-in-top">
              <div class="mb-3">
                <label class="form-label" for="whats-app-contact-contato1">
                  Contato 1
                </label>
                
                <input
                  id="whats-app-contact-contato1"
                  formControlName="contato1"
                  class="form-control"
                  autofocus
                />
                <div *ngIf="service.form.get('contato1').hasError('numberFormat') && service.form.get('contato1').touched" class="text-danger">
                  O número deve começar com +55 seguido de 10 ou 11 dígitos.
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label" for="whats-app-contact-contato2">
                  Contato 2
                </label>

                <input
                  id="whats-app-contact-contato2"
                  formControlName="contato2"
                  class="form-control"
                />
                <div *ngIf="service.form.get('contato2').hasError('numberFormat') && service.form.get('contato2').touched" class="text-danger">
                  O número deve começar com +55 seguido de 10 ou 11 dígitos.
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label" for="whats-app-contact-contato3">
                  Contato 3
                </label>

                <input
                  id="whats-app-contact-contato3"
                  formControlName="contato3"
                  class="form-control"
                />
                <div *ngIf="service.form.get('contato3').hasError('numberFormat') && service.form.get('contato3').touched" class="text-danger">
                  O número deve começar com +55 seguido de 10 ou 11 dígitos.
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label" for="whats-app-contact-contato4">
                  Contato 4
                </label>

                <input
                  id="whats-app-contact-contato4"
                  formControlName="contato4"
                  class="form-control"
                />
                <div *ngIf="service.form.get('contato4').hasError('numberFormat') && service.form.get('contato4').touched" class="text-danger">
                  O número deve começar com +55 seguido de 10 ou 11 dígitos.
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label" for="whats-app-contact-contato5">
                  Contato 5
                </label>

                <input
                  id="whats-app-contact-contato5"
                  formControlName="contato5"
                  class="form-control"
                />
                <div *ngIf="service.form.get('contato5').hasError('numberFormat') && service.form.get('contato5').touched" class="text-danger">
                  O número deve começar com +55 seguido de 10 ou 11 dígitos.
                </div>
              </div>
            </div>

      <!--<suite-custom-code-block-6>-->
      <!--</suite-custom-code-block-6>-->
    </form>
    <!--<suite-custom-code-block-8>-->
    <!--</suite-custom-code-block-8>-->
    <abp-button iconClass="fa fa-check" buttonType="submit" formName="whats-app-contact">
      Salvar
    </abp-button>
    <!--<suite-custom-code-block-9>-->
    <!--</suite-custom-code-block-9>-->
